import { Observable } from 'rxjs';
import { Component, OnChanges, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';

import { FormGroup, FormBuilder, Validators, FormArray, FormControl } from '@angular/forms';
import { Router, NavigationEnd } from '@angular/router';
import Swal from "sweetalert2";
import { MatSnackBar } from '@angular/material/snack-bar';
import { Store } from '@ngrx/store';
import { LandUseStatusDto } from '@cradua/data';

@Component({
  selector: 'cradua-land-use-status',
  templateUrl: './land-use-status.component.html',
  styleUrls: ['./land-use-status.component.scss']
})
export class LandUseStatusComponent implements OnChanges {


  landusestatusForm: FormGroup;
  landusestatusFormArray: FormGroup;
  control = new FormControl();
  @Input() landusestatuss: LandUseStatusDto[];
  @Input() routeAnimationsElements: any;
  @Output() landusestatus = new EventEmitter<LandUseStatusDto[]>()
  @Output() deleteLandUseStatusEvent = new EventEmitter<any>()

    selectedLandUseStatus: any;
    filteredDelete: Array<any> =[];
    loading = true;
    selectedIndex = null;
    constructor(
     private fb: FormBuilder,
     ) {}

    ngOnChanges() {
      this.createLandUseStatusForm();
    }

    createLandUseStatusForm() {
      this.landusestatusForm = this.fb.group({
        LandUseStatusName: ['', Validators.required],
     
        id: null
        });
        this.landusestatusFormArray = this.fb.group({ LandUseStatuss: this.fb.array([])
          });
        this.setLandUseStatus();
    }

  // method to display landusestatuss
  setLandUseStatus() {
    const control  = this.landusestatusFormArray.controls.LandUseStatuss as FormArray;
    this.landusestatuss.forEach( e => {
      control.push(
        this.fb.group({
          LandUseStatusName: e.LandUseStatusName,
        
          id: e.id
        })
      );
    });
  }


  // method to add LandUseStatus
  addLandUseStatus(value: LandUseStatusDto) {
    const control  = this.landusestatusFormArray.controls.LandUseStatuss as FormArray;
    control.insert(0,
          this.fb.group({
            LandUseStatusName: value.LandUseStatusName,
          
            id: null
          })
       );
  }

  selectLandUseStatus(value) {}

  // method to delete landusestatus from arrary list
  deleteLandUseStatus(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.landusestatusFormArray.controls.LandUseStatuss as FormArray;
  control.removeAt(index);
  for ( let i = 0; i < this.landusestatuss.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.landusestatuss[i].id);
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  addNew(formValue: LandUseStatusDto) {
    if(this.landusestatusForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.landusestatusFormArray.get('LandUseStatuss')['controls'][this.selectedIndex].patchValue({LandUseStatusName: formValue.LandUseStatusName});
    } else {
      this.addLandUseStatus(formValue);
    }
    this.selectedIndex = null;
    this.landusestatusForm.reset()
  }

  onEdit(index, value: LandUseStatusDto) {
    console.log(index, value)
    this.selectedIndex = index;
    this.landusestatusForm.patchValue({LandUseStatusName: value.LandUseStatusName});
   
  }

  onClearForm() {
    this.selectedIndex = null;
    this.landusestatusForm.reset();
  }

  onSubmit(formValue: LandUseStatusDto[]) {
  this.landusestatus.emit(formValue);
  if(this.filteredDelete.length !== 0) {
    this.deleteLandUseStatusEvent.emit(this.filteredDelete);
  }
  }

}

